import React from "react";
import MostPlayedButton from "../../UI/MostPlayedButton/MostPlayedButton";
import LeagueButton from "../../UI/LeagueButton/LeagueButton";
import CssClasses from "./MostPlayedOptions.css";
import { connect } from "react-redux";
import * as StoreActions from "../../../ReduxStore/Actions/ActionIndex";
import * as MostPlayedOptionIDs from "../../../HOCs/Constants/MostPlayedOptionID";
import * as Auxx from "../../../HOCs/AUXX/Auxx";

import * as PickerIDs from "../../../HOCs/Constants/PickerID";

import beepHigh from "../../../assets/sounds/beep_high.mp3";

let _props = null;

const MostPlayedOptions = props => {
  _props = props;

  const buttonTypes = [
    {
      id: MostPlayedOptionIDs.PREMATCH,
      icon: "chalice",
      title: "Prematch"
    },
    {
      id: MostPlayedOptionIDs.MOST_TIPPED,
      icon: "fire",
      title: "Najtipovaniji"
    },
    {
      id: MostPlayedOptionIDs.TOP_LEAGUES,
      icon: "star",
      title: "Top lige",
      additionalButtons: [
        { id: 1, title: "gumbek", iconID: 1 },
        { id: 2, title: "gumbek", iconID: 1 },
        { id: 3, title: "gumbek", iconID: 1 },
        { id: 4, title: "gumbek", iconID: 1 },
        { id: 5, title: "gumbek", iconID: 1 }
      ]
    },
    {
      id: MostPlayedOptionIDs.SUPERTIP,
      icon: "crown",
      title: "Supertip"
    },
    {
      id: MostPlayedOptionIDs.FAVORIT_PLUS,
      icon: "plus",
      title: "Favorit Plus"
    }
  ];

  let filteredBtns = buttonTypes;

  // let filteredBtns = buttonTypes.filter(
  //   x => x.id !== props.activeMostPlayedButtonID
  // );

  return (
    <div className={CssClasses.container}>
      <audio
        ref={sound => {
          this.beepHigh = sound;
        }}
      >
        <source src={beepHigh} type="audio/mpeg" />
      </audio>
      {filteredBtns.map(btn => {
        return (
          <div key={btn.id} className={CssClasses.btnContainer}>
            <MostPlayedButton
              icon={btn.icon}
              onButtonClicked={specialOptionButtonClick}
              title={btn.title}
              id={btn.id}
              isActive={btn.id === props.activeMostPlayedButtonID}
            />

            {/* {props.activeMostPlayedButtonID ===
              MostPlayedOptionIDs.TOP_LEAGUES &&
            props.leagueItems &&
            btn.id === MostPlayedOptionIDs.TOP_LEAGUES ? (
              <div className={CssClasses.leagueButtons}>
                {props.leagueItems.map(li => {
                  return (
                    <LeagueButton
                      onButtonClicked={leagueButtonClick}
                      titleCategory={li.CategoryTitle}
                      titleTournament={li.TournamentTitle}
                      key={li.TournamentID}
                      id={li.TournamentID}
                      isActive={li.TournamentID === props.activeLeagueID}
                      eventCount={li.EventCount}
                      sportID={li.SportID}
                    />
                  );
                })}
              </div>
            ) : null} */}
          </div>
        );
      })}
    </div>
  );
};

const specialOptionButtonClick = id => {
  //console.log("Button click.." + id);

  if (this.beepHigh) {
    this.beepHigh.play();
  }

  _props.onChangeLastUsedPicker(PickerIDs.MOST_PLAYED_OPTIONS);
  _props.onChangeMostPlayedButtonItem(id);

  //gasi liguz
  if (id === MostPlayedOptionIDs.TOP_LEAGUES) {
    //biraj sve lige
    _props.onChangeCurrentLeague(0);
  } else {
    //odznaci ligu
    console.log("RESETIRAM LIGU...");

    _props.onChangeCurrentLeague(-1);
  }

  //gasi extra bets ako su vanka
  _props.setShouldQuickCloseExtraBets(true);
  _props.setIsShowingBonusInfo(false);
  _props.onSetPrematchExtraBetsID(-1);
  _props.setCanShowExtraPrematchBets(true);

  //gasi i info ako je vani
  _props.setTerminalActionsActiveButton(0);

  setTimeout(() => {
    _props.setShouldQuickCloseExtraBets(false);
  }, 100);
};

const leagueButtonClick = id => {
  console.log("Button click.." + id);

  if (this.beepHigh) {
    this.beepHigh.play();
  }

  _props.onChangeCurrentLeague(id);
};

const mapStateToProps = state => {
  return {
    activeLeagueID: state.rrNavigation.leagueID,
    activeMostPlayedButtonID: state.rrNavigation.mostPlayedButtonID,
    updateTimestamp: state.rrSportEvent.updateTimestamp, //hack da povuce novi state i napravi rerender
    leagueItems: state.rrSportEvent.prematchLeagueItems
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onChangeMostPlayedButtonItem: buttonID =>
      dispatch(StoreActions.ChangeMostPlayedButtonItem(buttonID)),
    onChangeLastUsedPicker: pickerID =>
      dispatch(StoreActions.ChangeLastUsedPicker(pickerID)),
    onChangeCurrentLeague: leagueID =>
      dispatch(StoreActions.ChangeLeagueItem(leagueID)),
    setShouldQuickCloseExtraBets: shouldClose =>
      dispatch(StoreActions.SetShouldQuickCloseExtraBets(shouldClose)),
    onSetPrematchExtraBetsID: betsID =>
      dispatch(StoreActions.ChangeCurrentPrematchExtraBetsID(betsID)),
    setCanShowExtraPrematchBets: canShow =>
      dispatch(StoreActions.SetCanShowExtraPrematchBets(canShow)),
    setIsShowingBonusInfo: isShown =>
      dispatch(StoreActions.SetIsShowingBonusInfo(isShown)),
    setTerminalActionsActiveButton: buttonID =>
      dispatch(StoreActions.SetTerminalActionsActiveButton(buttonID))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MostPlayedOptions);



// WEBPACK FOOTER //
// ./src/Components/Navigation/MostPlayedOptions/MostPlayedOptions.js